﻿import { type UseTracking } from './types';

export function useTracking(): UseTracking {
  const track = async (): Promise<void> => {
    try {
      return;
    } catch (error) {
      throw new Error(`Failed to track: ${error}`);
    }
  };

  return { track };
}
